import { useMemo } from "react";

const HEBREW_MONTHS = [
  "ינואר", "פברואר", "מרץ", "אפריל", "מאי", "יוני",
  "יולי", "אוגוסט", "ספטמבר", "אוקטובר", "נובמבר", "דצמבר",
];

export function getNextTuesday(): Date {
  const now = new Date();
  const day = now.getDay(); // 0=Sun, 2=Tue
  let daysUntil = (2 - day + 7) % 7;

  // If it's Tuesday but past 20:30, move to next week
  if (daysUntil === 0) {
    const cutoff = new Date(now);
    cutoff.setHours(20, 30, 0, 0);
    if (now >= cutoff) {
      daysUntil = 7;
    }
  }

  const next = new Date(now);
  next.setDate(now.getDate() + daysUntil);
  next.setHours(20, 30, 0, 0);
  return next;
}

export function useNextTuesday() {
  return useMemo(() => {
    const next = getNextTuesday();
    const now = new Date();
    const diffMs = next.getTime() - now.getTime();
    const daysUntil = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

    const dateLabel = `יום שלישי, ${next.getDate()} ב${HEBREW_MONTHS[next.getMonth()]}`;

    return { nextTuesday: next, daysUntil, dateLabel };
  }, []);
}
